const PaymentSuccessModal = ({
  onClose,
  onGoToJobs
}) => {
  return (
    <div className="payment-modal-overlay">
      <div className="payment-success-modal">

        <div className="payment-success-icon">
          ✓
        </div>

        <h2>Payment Successful!</h2>

        <p>
          Your payment has been completed successfully.
        </p>

        <button
          type="button"
          onClick={onGoToJobs}
        >
          Ok
        </button>

      </div>
    </div>
  );
};

export default PaymentSuccessModal;